var exports = {
  "kL": "AudioPlayer.module__container___VDBXZT",
  "Md": "AudioPlayer.module__fileName___VDBXZT",
  "NE": "AudioPlayer.module__progressSection___VDBXZT",
  "hr": "AudioPlayer.module__progressBar___VDBXZT",
  "Ey": "AudioPlayer.module__timeDisplay___VDBXZT",
  "ne": "AudioPlayer.module__controls___VDBXZT",
  "gm": "AudioPlayer.module__mainControls___VDBXZT",
  "Rr": "AudioPlayer.module__playButton___VDBXZT",
  "$3": "AudioPlayer.module__seekButton___VDBXZT",
  "f6": "AudioPlayer.module__secondaryControls___VDBXZT",
  "Wq": "AudioPlayer.module__volumeControl___VDBXZT",
  "Sn": "AudioPlayer.module__playbackRate___VDBXZT",
  "Hw": "AudioPlayer.module__mobile___VDBXZT",
};

module.exports = exports;
